import ConnectSocialMediaPlatforms from "./pages/social_media_connections/ConnectSocialMediaPlatforms";
import VideoTutorial from "./pages/VideoTutorial";

export interface Tutorial {
    id: number;
    title: string;
    description: string;
    link: string;
    component?: React.FC;
}

export const tutorialsData: Tutorial[] = [
    {
        id: 1,
        title: "Social Media Connection Instructions",
        description:
            "Get Platform-specific instructions for connecting your social media accounts to Marabot",
        link: "social-media-connection-instructions",
        component: ConnectSocialMediaPlatforms,
    },
    {
        id: 2,
        title: "Marabot Video Tutorials",
        description: "Get a step-by-step guide to using Marabot",
        link: "create-non-mls-listing",
        component: VideoTutorial,
    },
    {
        id: 3,
        title: "Create MLS Listing",
        description: "Get a step-by-step guide to creating an MLS listing",
        link: "create-mls-listing",
        component: VideoTutorial,
    },
    {
        id: 4,
        title: "Create Campaign",
        description: "Get a step-by-step guide to creating a campaign",
        link: "create-campaign",
        component: VideoTutorial,
    },
    {
        id: 5,
        title: "Create Slideshow",
        description: "Get a step-by-step guide to creating a slideshow",
        link: "create-slideshow",
        component: VideoTutorial,
    },
    {
        id: 6,
        title: "Using Videos",
        description: "Get a step-by-step guide to using videos",
        link: "using-videos",
        component: VideoTutorial,
    },
    {
        id: 7,
        title: "Schedule an Open House",
        description: "Get a step-by-step guide to creating open house posts",
        link: "schedule-an-open-house",
        component: VideoTutorial,
    },
    {
        id: 8,
        title: "Create a Neighborhood Expert Campaign",
        description: "Get a step-by-step guide to creating a neighborhood expert campaign",
        link: "create-neighborhood-expert-campaign",
        component: VideoTutorial,
    }
];
